import AssessmentCandidatePage from "./AssessmentCandidatePage";

const CoderbyteCandidate = () => {
  return <AssessmentCandidatePage provider="coderbyte" />;
};

export default CoderbyteCandidate;
